"use strict";
import React, { useRef } from "react";
import { Transition, TransitionGroup } from "react-transition-group";
import forceReflow from "../../../utils/forceReflow";
import classNames from "classnames";
import { AnimationDuration } from "../../../styles/Animations";
const getCurrentGap = (node) => {
  if (!node.parentElement || node.parentElement.childElementCount === 1) {
    return "0px";
  }
  const rowGap = window.getComputedStyle(node.parentElement).rowGap;
  const isNumeric = !!parseInt(rowGap, 10);
  if (!isNumeric) {
    return "0px";
  }
  return rowGap;
};
export const Expandable = ({
  children,
  className,
  onEnter,
  onEntered,
  onExit,
  expanded,
  element: Element = "div",
  timeout = AnimationDuration.Medium,
  ...rest
}) => {
  const expandableElementRef = useRef(null);
  return /* @__PURE__ */ React.createElement(TransitionGroup, { component: null, timeout }, expanded && /* @__PURE__ */ React.createElement(
    Transition,
    {
      timeout,
      onEnter: (node, isAppearing) => {
        node.style.height = "0px";
        node.style.setProperty("--expandable-gap-size", getCurrentGap(node));
        forceReflow(node);
        onEnter?.(node, isAppearing);
        requestAnimationFrame(() => {
          node.style.height = `${expandableElementRef.current?.offsetHeight}px`;
        });
      },
      onEntered: (node, isAppearing) => {
        forceReflow(node);
        onEntered?.(node, isAppearing);
        requestAnimationFrame(() => {
          node.style.height = "auto";
          node.style.setProperty("--expandable-gap-size", null);
        });
      },
      onExit: (node) => {
        node.style.height = `${expandableElementRef.current?.offsetHeight}px`;
        node.style.setProperty("--expandable-gap-size", getCurrentGap(node));
        forceReflow(node);
        onExit?.(node);
        requestAnimationFrame(() => {
          node.style.height = "0px";
        });
      },
      ...rest
    },
    (status) => /* @__PURE__ */ React.createElement(
      Element,
      {
        className: classNames("kl-expandable", `kl-expandable--${status}`, className, {
          [`${className}--${status}`]: className
        }),
        style: { "--duration": `${timeout}ms` }
      },
      children({ status, expandableElementRef })
    )
  ));
};
